import {
  getMemberDetailsFromUserDetails,
  type MemberAPIResponse,
} from '@assembly-web/services';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { TextStyle } from '../../../../../DesignSystem/Feedback/TextStyle';
import { TextField } from '../../../../../DesignSystem/Inputs/TextField';
import { ChallengeCard } from '../../../Challenges/Card/ChallengeCard';
import { PostInteractionSettingItem } from '../../AnnouncementCenterModal/PostInteractionSettingItem';
import { dummyReactions, dummyReplies } from '../data';
import { messages } from '../message';

export function CustomizeAndStyling({
  userDetails,
}: {
  userDetails: MemberAPIResponse;
}) {
  const { formatMessage } = useIntl();
  const {
    register,
    control,
    formState: { errors },
    getValues,
    watch,
  } = useFormContext();
  const claimButtonError = errors.claimButtonText?.message as string;
  const inputClassName = 'mt-1 placeholder:text-gray-8 text-sm';
  const labelClassName = 'text-sm font-medium';
  const { title, description, points, individualClaimLimit, totalClaimLimit } =
    getValues();
  const { claimButtonText, interactionSettings } = watch();
  return (
    <div className="flex flex-col gap-2">
      <div>
        <TextField
          {...register('claimButtonText')}
          type="text"
          placeholder={formatMessage(messages.buttonPlaceholder)}
          invalidText={claimButtonError}
          label={formatMessage(messages.customizeClaimButton)}
          isInvalid={Boolean(claimButtonError)}
          inputClassName={inputClassName}
          labelClassName={labelClassName}
          aria-label={'claimButtonText'}
          helpText={formatMessage(messages.buttonLimitHintLabel)}
        />
      </div>
      <section>
        <TextStyle as="span" variant="sm-medium">
          {formatMessage(messages.interactionSettings)}
        </TextStyle>
        <TextStyle variant="xs-regular" className="text-gray-9">
          {formatMessage(messages.postInteractionSettingsDescriptionLabel)}
        </TextStyle>

        <Controller
          name="interactionSettings.hideReplies"
          control={control}
          render={({ field: { onChange, value } }) => (
            <PostInteractionSettingItem
              className="mt-2"
              disabled={false}
              isChecked={!value}
              onCheckedChange={(val) => onChange(!val)}
              label={formatMessage(messages.allowRepliesLabel)}
            />
          )}
        />

        <Controller
          name="interactionSettings.hideReactions"
          control={control}
          render={({ field: { onChange, value } }) => (
            <PostInteractionSettingItem
              className="my-2"
              disabled={false}
              isChecked={!value}
              onCheckedChange={(val) => onChange(!val)}
              label={formatMessage(messages.allowReactionsLabel)}
            />
          )}
        />
      </section>
      <TextStyle as="span" variant="sm-medium">
        {formatMessage(messages.cardPreviewTitle)}
      </TextStyle>
      <ChallengeCard
        title={title}
        description={description}
        points={points}
        state={'ACTIVE'}
        type={'STANDALONE'}
        createdBy={getMemberDetailsFromUserDetails(userDetails.member)}
        claimButtonText={claimButtonText}
        reactions={dummyReactions}
        isUserAdmin={false}
        hideReactions={interactionSettings?.hideReactions}
        hideReplies={interactionSettings?.hideReplies}
        launchDate={new Date().toDateString()}
        claimsRemaining={totalClaimLimit > 0 ? totalClaimLimit : ''}
        canEdit={false}
        selfClaimDetails={{
          totalCount: individualClaimLimit,
          totalEarnedPoints: 10,
          claims: [],
        }}
        repliesData={dummyReplies}
        currency={userDetails.assembly.currency}
        currentUserDetails={getMemberDetailsFromUserDetails(userDetails.member)}
      />
    </div>
  );
}
